import { UIElement } from './uiElement';
import { IKeyValue } from '../../../interfaces';
import { CalendarOptions, DateTimePickerOptions } from '../../../interfaces/options';
import { DefaultDateTimePickerOptions } from '../../../const/defaultOptions';

export class DateTimePicker extends UIElement<Date> {
	private calendarOptions: CalendarOptions;
	private dateLabel: KnockoutComputed<string>;
	constructor(
		id: string,
		label: string,
		value: Date | KnockoutObservable<Date>,
		options?: DateTimePickerOptions
	) {
		options = $.extend(true, {}, DefaultDateTimePickerOptions, options || {});
		super(id, label, value, options);
		this.calendarOptions = options.calendar;
		this.calendarOptions.value = this.value;
	}

	//Overwrite
	public serialize(serializeObject: IKeyValue<string>): IKeyValue<string> {
		var utc: string = null,
			date: Date = this.value();
		if (date != null) {
			utc = date.toISOString();
		}
		serializeObject[this.id] = utc;
		return serializeObject;
	}
}
